export function periodicidadeLabel(periodicidade) {
  const p = String(periodicidade || "").trim().toUpperCase();
  if (p === "QUINZENAL") return "Quinzenal";
  if (p === "MENSAL") return "Mensal";
  if (p === "TRIMESTRAL") return "Trimestral";
  if (p === "SEMESTRAL") return "Semestral";
  if (p === "SEMANAL") return "Semanal";
  if (p === "ANUAL") return "Anual";
  return p ? `${p[0]}${p.slice(1).toLowerCase()}` : "";
}

function limparNomeBasePreventiva(nome) {
  const texto = String(nome || "").trim();
  if (!texto) return "";

  return texto
    .replace(/\bpreventiva\b/gi, "")
    .replace(/\b(quinzenal|mensal|trimestral|semestral|semanal|anual)\b/gi, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function montarNomeExibicaoPreventiva(item) {
  const per = periodicidadeLabel(item?.periodicidade) || "Preventiva";
  const baseLimpa = limparNomeBasePreventiva(item?.nome || item?.preventivaNome);
  const baseOriginal = String(item?.nome || item?.preventivaNome || "").trim();
  const base = baseLimpa || baseOriginal;
  return base ? `Preventiva ${per} ${base}`.replace(/\s+/g, " ").trim() : `Preventiva ${per}`;
}
